// eslint-disable-next-line id-length -- matches useTranslation().t; literal t("chat:error.…") keys for grep / i18n extractors
export default function getFlaggingReasons(t) {
    return [
        {
            label: t("chat:modal.reportMessage.reason.underageContent"),
            value: "underage_content",
        },
        {
            label: t("chat:modal.reportMessage.reason.nonConsensualActivities"),
            value: "non_consensual",
        },
        {
            label: t("chat:modal.reportMessage.reason.incestuousRelationship"),
            value: "incestuous_relationship",
        },
        { label: t("chat:modal.reportMessage.reason.hateSpeech"), value: "hate_speech" },
        {
            label: t("chat:modal.reportMessage.reason.extremeViolence"),
            value: "extreme_violence",
        },
        { label: t("chat:modal.reportMessage.reason.selfHarm"), value: "self_harm" },
        { label: t("chat:modal.reportMessage.reason.bestiality"), value: "bestiality" },
        { label: t("chat:modal.reportMessage.reason.others"), value: "others" },
    ];
}
